import { DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { getInitialConditionalAction, getRouteToCallback } from '../../../utils/formattersUtils';
import styles from './IncludedContentFormatter.module.scss';

const cx = classNames.bind(styles);

const IncludedContentFormatter: DataItemFormatter<string, ReactElement, { onItemClick? }> = ({
  value: summary,
  item,
  row,
  configuration,
  props,
}): ReactElement => {
  const routeToCallback = getRouteToCallback(configuration, item);
  const initialConditionalAction = getInitialConditionalAction(configuration, row, props, item);

  return (
    <Link to={routeToCallback} className={cx('body')} onClick={initialConditionalAction} data-testid="title-formatter">
      <p className={cx('content')}>{summary}</p>
    </Link>
  );
};

export default IncludedContentFormatter;
